import { render, staticRenderFns } from "./chartNewMember.vue?vue&type=template&id=ff6adf2c&scoped=true&"
import script from "./chartNewMember.vue?vue&type=script&lang=js&"
export * from "./chartNewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6adf2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff6adf2c')) {
      api.createRecord('ff6adf2c', component.options)
    } else {
      api.reload('ff6adf2c', component.options)
    }
    module.hot.accept("./chartNewMember.vue?vue&type=template&id=ff6adf2c&scoped=true&", function () {
      api.rerender('ff6adf2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/overview/chartNewMember.vue"
export default component.exports